
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 14 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2 13.667c-.459 0-.851-.164-1.177-.49A1.605 1.605 0 01.333 12V9.5H2V12h10V9.5h1.666V12c0 .458-.163.85-.49 1.177-.326.326-.718.49-1.176.49H2zm5-3.334L2.833 6.167 4 4.958l2.166 2.167V.333h1.667v6.792L10 4.958l1.166 1.209L7 10.333z"}})])
          )
        }
      }
    